module.exports = __webpack_public_path__ + "static/img/offer.18ffc60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/offer.png
// module id = 1152
// module chunks = 173